import { render, staticRenderFns } from "./TareaModal.vue?vue&type=template&id=f5dd43c8&scoped=true"
import script from "./TareaModal.vue?vue&type=script&lang=js"
export * from "./TareaModal.vue?vue&type=script&lang=js"
import style0 from "./TareaModal.vue?vue&type=style&index=0&id=f5dd43c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dd43c8",
  null
  
)

export default component.exports